// features/premium/panels/PremiumTierPanel.tsx — rail for the subscribed view.
import styled from 'styled-components';
import { Panel, SectionLabel, Badge } from '@/ui';
import { useBilling } from '@/hooks';

const BadgeRow = styled.div`margin-bottom: 12px;`;
const Facts = styled.dl`display: grid; grid-template-columns: auto 1fr; gap: 6px 14px; margin: 0; & dt { color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; } & dd { margin: 0; color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.xs}; }`;

function formatDate(iso: string | null): string {
  if (!iso) return 'Not set';
  try {
    return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return 'Not set';
  }
}

export function PremiumTierPanel() {
  const { billing } = useBilling();
  return (
    <Panel>
      <SectionLabel as="h2">Premium Tier</SectionLabel>
      <BadgeRow><Badge>Pro</Badge></BadgeRow>
      {billing && (
        <Facts>
          <dt>Plan</dt><dd>Pro</dd>
          <dt>Status</dt><dd>{billing.status || 'active'}</dd>
          <dt>{billing.cancelAtPeriodEnd ? 'Ends' : 'Renews'}</dt>
          <dd>{formatDate(billing.currentPeriodEnd)}</dd>
        </Facts>
      )}
    </Panel>
  );
}
